var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
import { TABLET_WIDTH } from '@codex/utils/constants';
var styles = (_a = {
        root: {
            width: 763,
            // height: 627,
            backgroundColor: "#ffffff",
            margin: "100px auto",
            display: "flex",
            flex: "auto",
            flexDirection: "column"
        },
        header: {
            flex: "0 0 auto",
            width: 763,
            minHeight: 100,
            padding: "22px 0"
        },
        main: (_b = {
                flex: "auto",
                // padding: "40px 50px 20px",
                padding: "29px 89px 20px",
                textAlign: "right",
                minHeight: 435
            },
            _b["&.page-6"] = (_c = {
                    minHeight: "auto",
                    height: "366px",
                    boxSizing: "border-box",
                    textAlign: "center",
                    paddingTop: 42,
                    direction: "rtl"
                },
                _c["& .header"] = {
                    width: 452,
                    height: 104,
                    fontFamily: "Assistant",
                    fontSize: 28,
                    lineHeight: 1.43,
                    textAlign: "center",
                    color: "#5a5a6c",
                    margin: "21px auto 26px"
                },
                _c["& .ending-words"] = (_d = {
                        width: '544px',
                        height: '70px',
                        fontSize: 20,
                        lineHeight: 1.7,
                        textAlign: 'center',
                        color: '#5a5a6c',
                        margin: 'auto'
                    },
                    _d["& a"] = (_e = {
                            color: '#4bb0dd'
                        },
                        _e["&:hover"] = {
                            textDecoration: "underline"
                        },
                        _e),
                    _d),
                _c),
            // ["&.page-1, &.page-2, &.page-3"]: {
            // },
            _b["&.page-2, &.page-3"] = {
                paddingBottom: "10px"
            },
            _b["&.page-5"] = {
                padding: "40px 50px 20px",
            },
            _b),
        footer: {
            flex: "0 0 auto",
            display: "flex",
            direction: "rtl",
            overflow: "hidden"
        },
        actors: {
            backgroundColor: "#f3f6f7",
            padding: "0 44px",
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-between",
            alignItems: "flex-end"
        },
        hero: {
            width: 58,
            height: 44,
            objectFit: "contain"
        },
        actorsCenter: {
            backgroundColor: "#f3f6f7",
            padding: "0 44px",
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "center",
            alignItems: "flex-end"
        },
        celebration: {
            width: 216,
            height: 75,
            objectFit: "contain",
            position: "relative",
            top: 6
        },
        coins: {
            width: 25,
            height: 19,
            objectFit: "contain"
        },
        apple: {
            width: 26,
            height: 29,
            objectFit: "contain"
        },
        progress: (_f = {
                top: 4,
                transform: "scale(1.1)",
                transformOrigin: "left center",
                position: "relative"
            },
            _f["& .ant-progress-bg"] = {
                border: "solid 1px #ceced2",
                boxSizing: 'border-box'
            },
            _f["&.active .ant-progress-bg"] = {
                borderWidth: "0 !important"
            },
            _f),
        progress1: (_g = {
                zIndex: 3
            },
            _g["&.active"] = (_h = {},
                _h["&.ant-progress-inner"] = {
                    boxShadow: "0 0 6px 1px rgba(75, 176, 221, 0.36)",
                },
                _h),
            _g),
        progress2: (_j = {
                zIndex: 2
            },
            _j["&.active"] = (_k = {},
                _k["& .ant-progress-inner"] = {
                    boxShadow: "0 0 6px 1px rgba(242, 100, 139, 0.36)",
                },
                _k),
            _j),
        progress3: (_l = {
                zIndex: 1
            },
            _l["&.active"] = (_m = {},
                _m["& .ant-progress-inner"] = {
                    boxShadow: "0 0 6px 1px rgba(51, 196, 210, 0.36)",
                },
                _m),
            _l),
        progress4: (_o = {},
            _o["&.active"] = (_p = {},
                _p["& .ant-progress-inner"] = {
                    boxShadow: "0 0 6px 1px rgba(157, 94, 204, 0.36)",
                },
                _p),
            _o),
        btn: (_q = {
                width: 132,
                height: 43,
                borderRadius: 25.4,
                backgroundColor: "#f2648b",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            _q["&:hover"] = {
                backgroundColor: "#f2648b"
            },
            _q["&:focus"] = {
                backgroundColor: "#f2648b"
            },
            _q["& span"] = {
                fontSize: 16,
                fontWeight: "bold",
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: "normal",
                letterSpacing: "normal",
                textAlign: "center",
                color: "#ffffff"
            },
            _q),
        btnContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: 39,
            position: 'relative'
        },
        spanContainer: {
            width: '100px',
            height: 43,
            borderRadius: 25.4,
            cursor: 'pointer',
            position: 'absolute',
            right: '0',
            top: '50%',
            transform: 'translateY(-50%)',
            border: '1px solid #4bb0dd',
            textAlign: 'center',
            lineHeight: '41px',
        },
        pageHeader: (_r = {
                fontSize: 28,
                fontWeight: 600,
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: 0.79,
                letterSpacing: "normal",
                textAlign: "center",
                color: "#ffffff",
                paddingBottom: 10
            },
            _r["&.large"] = (_s = {
                    paddingBottom: 0,
                    lineHeight: "56px",
                    height: "56px",
                    fontSize: 38
                },
                _s["& > span"] = {
                    lineHeight: "56px",
                    fontFamily: "OpenSansHebrew Extra Bold",
                    fontWeight: 800,
                },
                _s),
            _r),
        pageSubHeader: {
            fontSize: 16,
            fontWeight: "normal",
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: 1.5,
            letterSpacing: "normal",
            textAlign: "center",
            color: "#ffffff"
        }
    },
    _a["@media screen and (max-width:" + TABLET_WIDTH + "px)"] = {
        root: {
            width: 320,
            margin: '90px auto'
        },
        header: {
            width: 320,
            minHeight: 95,
            padding: '11px 0'
        },
        hero: {
            width: 44,
            height: 33,
            objectFit: 'contain'
        },
        coins: {
            width: 12,
            height: 9,
            objectFit: 'contain'
        },
        apple: {
            width: 16,
            height: 18,
            objectFit: 'contain'
        },
        actors: {
            padding: '0 20px',
        },
        pageHeader: (_t = {
                fontSize: '20px !important',
                lineHeight: 1.2,
                paddingBottom: 6
            },
            _t["&.large"] = {
                height: 0,
                lineHeight: "21px",
                fontSize: '25px !important',
                paddingTop: 5
            },
            _t),
        pageSubHeader: {
            fontSize: 14
        },
        main: (_u = {
                padding: "26px 10px 10px 10px !important"
            },
            _u["&.page-6"] = (_v = {
                    height: "292px !important"
                },
                _v["& > img"] = {
                    width: 46,
                    height: 47,
                    objectFit: "contain"
                },
                _v["& .header"] = {
                    margin: "22px auto 0 !important",
                    width: "273px !important",
                    height: "84px !important",
                    fontSize: "20px !important"
                },
                _v["& .ending-words"] = {
                    fontSize: "14px !important",
                    width: "273px !important",
                    height: "78px !important",
                },
                _v),
            _u),
        btnContainer: {
            marginTop: 38,
            marginBottom: 12,
            flexDirection: 'column',
            alignItems: 'center',
        },
        spanContainer: {
            position: 'static',
            transform: 'none',
            marginTop: 10
        },
    },
    _a["@media screen and (max-width:320px)"] = {
        root: {
            width: '90%'
        },
        header: {
            width: '100%'
        }
    },
    _a);
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/containers/SurvayLayout/styles.ts
// module id = 1387
// module chunks = 0